module.exports = __webpack_public_path__ + "media/images/add-video-img-6a1ea216bbe05cd25057b19485057765.svg";